export default __webpack_public_path__ + "static/media/close.6b56d8f0.svg";